import {
  Box,
  Button,
  Container,
  makeStyles,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Page from 'src/components/Page';
import DataTable from 'src/components/Table/DataTable';
import { useDispatch, useSelector } from 'react-redux';
import { getAPICodeData } from 'src/store/actions/KeyManagerActions';
import CreateAPIKey from './CreateAPIKey';
import UpdateAPIKey from './UpdateAPIKey';
import UpdateAPIStatus from './UpdateAPIStatus';
import { FullscreenExit } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  datatable: {
    marginTop: theme.spacing(2)
  },
  box: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  table: {
    minWidth: 750
    // minHeight: 500
  }
}));

const tableHead = [
  { title: 'SN' },
  { title: 'Key Alias' },
  { title: 'User ID' },
  { title: 'Status' },
  { title: 'Actions' }
];

const KeyManager = () => {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openUpdateStatus, setOpenUpdateStatus] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [apiCodeDataList, setApiCodeDataList] = useState([]);
  const dispatch = useDispatch();

  const apiData = useSelector(state => state.ApiKey.apiCodeData);

  useEffect(() => {
    async function callGetAPICodeData() {
      setLoading(true);
      const response = await dispatch(getAPICodeData());
      if (response) {
        setLoading(false);
      }
    }
    callGetAPICodeData();
  }, []);

  useEffect(() => {
    setApiCodeDataList(apiData);
  }, [apiData]);

  const handleOpenCreateModal = () => {
    setOpen(true);
  };

  const handleCloseCreateModal = () => {
    setOpen(false);
  };

  const handleOpenUpdateModal = item => {
    setOpenUpdate(true);
    setCurrentItem(item);
  };

  const handleOpenUpdateStatusModal = item => {
    setOpenUpdateStatus(true);
    setCurrentItem(item);
  };

  return (
    <>
      <CreateAPIKey open={open} handleClose={handleCloseCreateModal} />
      <UpdateAPIKey
        open={openUpdate}
        handleClose={() => setOpenUpdate(false)}
        item={currentItem}
        // handle
      />
      <UpdateAPIStatus
        open={openUpdateStatus}
        handleClose={() => setOpenUpdateStatus(false)}
        item={currentItem}
      />
      <Page className={classes.root} title="KeyManager">
        <Container maxWidth="lg">
          <Box className={classes.box}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenCreateModal}
            >
              Create API Key
            </Button>
          </Box>

          <Box>
            <DataTable
              className={classes}
              loading={loading}
              tableHead={tableHead}
              tableData={apiCodeDataList}
              handleUpdateAPICode={handleOpenUpdateModal}
              handleUpdateAPIStatus={handleOpenUpdateStatusModal}
            />
          </Box>
        </Container>
      </Page>
    </>
  );
};

export default KeyManager;
